import React from 'react';
import PropTypes from 'prop-types';

import onlyNumbers from '../../utils/onlyNumbers';

import { RangeNavigationStyle } from './RangeNavigationStyle';

const RangeNavigation = ({
  theme,
  value,
  step,
  minimum,
  maximum,
  handleChange,
}) => {
  const onChangeInputRange = (event) => {
    if (event?.target?.value?.length) {
      let currentStep = onlyNumbers(event?.target?.value);

      if (currentStep?.length) {
        currentStep = parseInt(currentStep, 10);

        if (currentStep <= minimum) {
          currentStep = minimum;
        }

        if (currentStep >= maximum) {
          currentStep = maximum;
        }

        handleChange(currentStep);
      }
    }
  };

  return (
    <RangeNavigationStyle className={`${theme}-theme`}>
      <input
        className="input-range-element"
        type="range"
        value={value}
        min={minimum}
        max={maximum}
        step={step}
        onChange={onChangeInputRange}
      />
    </RangeNavigationStyle>
  );
};

RangeNavigation.propTypes = {
  theme: PropTypes.string,
  value: PropTypes.number,
  step: PropTypes.number,
  minimum: PropTypes.number,
  maximum: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
};

RangeNavigation.defaultProps = {
  theme: 'default',
  value: 1,
  step: 1,
  minimum: 1,
  maximum: 1,
};

export default RangeNavigation;
